<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.meeting_turns', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.create'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.school_year_id')" for="school_year_id" />
                            <FormSelect
                                required
                                id="school_year_id"
                                v-model="form.school_year_id"
                                :options="options.school_years"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.school_year_id" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.group_id')" for="group_id" />
                            <FormSelect
                                required
                                id="group_id"
                                v-model="form.group_id"
                                :options="options.groups"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.group_id" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.status')" for="status" />
                            <FormInput
                                required
                                id="status"
                                v-model="form.status"
                                name="status"
                                type="text"
                                max="60"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.status" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.date')" for="date" />
                            <FormInput required id="date" v-model="form.date" name="date" type="text" class="mt-1" />
                            <FormError :value="form.errors.date" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.start_time')" for="start_time" />
                            <FormInput
                                required
                                id="start_time"
                                v-model="form.start_time"
                                name="start_time"
                                type="text"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.start_time" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.duration')" for="duration" />
                            <FormInput
                                required
                                id="duration"
                                v-model="form.duration"
                                name="duration"
                                type="text"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.duration" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.datetime_start')" for="datetime_start" />
                            <FormInput
                                required
                                id="datetime_start"
                                v-model="form.datetime_start"
                                name="datetime_start"
                                type="date"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.datetime_start" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.datetime_end')" for="datetime_end" />
                            <FormInput
                                required
                                id="datetime_end"
                                v-model="form.datetime_end"
                                name="datetime_end"
                                type="date"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.datetime_end" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.comment')" for="comment" />
                            <FormInput id="comment" v-model="form.comment" name="comment" type="text" class="mt-1" />
                            <FormError :value="form.errors.comment" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-5">
                <AppButton desired-action element="button" type="submit" :disabled="form.processing">
                    {{ $t('messages.save') }}
                    <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                </AppButton>
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    components: {
        PanelPage,
        TitleFieldsFormSection,
        FormInput,
        FormLabel,
        FormError,
        FormSelect,
        AppButton,
    },
    layout: Layout,
    name: 'Create',
    props: ['meta', 'options'],
    data() {
        return {
            form: this.$inertia.form({
                school_year_id: '',
                group_id: '',
                status: '',
                date: '',
                start_time: '',
                duration: '',
                datetime_start: '',
                datetime_end: '',
                comment: '',
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.store);
        },
    },
};
</script>
